import React from "react";
import Reports from "./Reports";

const ClientReport = () => <Reports reportType="client" />;

export default ClientReport;
